import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
	token:'',
	userid:null,
	active:1,
	filtering:{},
	advertiser_id:null,
	rule_advertiser_id:''
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
	UpdateAdvertiserId(state,advertiser_id){
		state.advertiser_id = advertiser_id
	},
	UpdateActive(state,num){
		state.active = num
	},
	UpdateFiltering(state,obj)
	{
		state.filtering = obj
	},
	UpdateRuleAdvertiserId(state,advertiser_id)
	{
		state.rule_advertiser_id = advertiser_id
	}
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations,
	plugins: [createPersistedState({
		storage: window.sessionStorage,
		reducer(val) {
          return {
          // 只储存state中的user
          active: val.active
         }
		}
	})]
})


// WEBPACK FOOTER //
// ./src/vuex/store.js